<template>
  <div class="be-creator">
    <div class="container">
      <h2 class="mt-5">Are you our next star?</h2>
      <p class="mt-4">
        If you think you have the right mix of ingredients to join our creators
        and get a publishing deal for your dream book, please get in contact by
        filling in our form. We look forward to hearing from you.
      </p>
      <CreatorForm />
    </div>
  </div>
</template>

<script>
import { creatorsFeedback, creatorsQuotes } from './constants';
import CreatorForm from '@/components/CreatorForm';

import { fetchOneCreator } from '@/services/creators';

export default {
  name: 'BeCreator',

  components: {
    CreatorForm
  },

  asyncData({ $axios, error }) {
    return Promise.all(
      creatorsFeedback.map((creator) =>
        fetchOneCreator($axios, creator.handle).then((result) => ({
          ...result,
          feedback: creator.feedback
        }))
      )
    )
      .then((creators) => {
        return { creators };
      })
      .catch(() => {
        error({ statusCode: 500 });
      });
  },

  data() {
    return {
      creatorsQuotes
    };
  },

  head: {
    title: 'Be Found | Publishing the unpublished',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Be Found! - We create unique personalised books for passionate creators to publish their online content, creating deeper connections with their online followers.'
      }
    ]
  },

  async mounted() {
    await this.$recaptcha.init();
  },

  beforeDestroy() {
    this.$recaptcha.destroy();
  }
};
</script>

<style lang="scss" scoped>
.be-creator {
  .share-button {
    right: 15px !important;
    bottom: 30px !important;
  }

  &__banner {
    margin-top: -55px;
    background-size: auto 110%;
    background-repeat: no-repeat;
    background-position: top center;
    height: 350px;

    @media (min-width: $screen-width-lg) {
      background-size: 100% auto;
      height: 500px;
    }

    @media (min-width: $screen-width-md) {
      background-position: bottom center;
    }
  }

  .yellow-text {
    color: $primary-color;
  }

  &__quote {
    h4 {
      line-height: 1.4;
      max-width: 375px;
      margin: 0 auto;
    }
  }

  &__video {
    @media (min-width: $screen-width-md) {
      width: 50%;
      margin: 0 auto;
    }
  }
}
</style>
